module.exports = __webpack_public_path__ + "img/lego-bg-md.0eac0c37.jpg";